// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://etherscan.io/address/0xcfBf336fe147D643B9Cb705648500e101504B16d
export const POOL_ADDRESSES_PROVIDER = '0xcfBf336fe147D643B9Cb705648500e101504B16d';

// IPool https://etherscan.io/address/0x4e033931ad43597d96D6bcc25c280717730B58B1
export const POOL = '0x4e033931ad43597d96D6bcc25c280717730B58B1';

// IPoolConfigurator https://etherscan.io/address/0x342631c6CeFC9cfbf97b2fe4aa242a236e1fd517
export const POOL_CONFIGURATOR = '0x342631c6CeFC9cfbf97b2fe4aa242a236e1fd517';

// IAaveOracle https://etherscan.io/address/0xE3C061981870C0C7b1f3C4F4bB36B95f1F260BE6
export const ORACLE = '0xE3C061981870C0C7b1f3C4F4bB36B95f1F260BE6';

// https://etherscan.io/address/0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A
export const ACL_ADMIN = '0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A';

// IACLManager https://etherscan.io/address/0x013E2C7567b6231e865BB9273F8c7656103611c0
export const ACL_MANAGER = '0x013E2C7567b6231e865BB9273F8c7656103611c0';

// IPoolDataProvider https://etherscan.io/address/0xB85B2bFEbeC4F5f401dbf92ac147A3076391fCD5
export const AAVE_PROTOCOL_DATA_PROVIDER = '0xB85B2bFEbeC4F5f401dbf92ac147A3076391fCD5';

// https://etherscan.io/address/0xC313A383D1838dCDA96f4c97698238F0A5499eA4
export const POOL_IMPL = '0xC313A383D1838dCDA96f4c97698238F0A5499eA4';

// https://etherscan.io/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://etherscan.io/address/0x8164Cc65827dcFe994AB23944CBC90e0aa80bFcb
export const DEFAULT_INCENTIVES_CONTROLLER = '0x8164Cc65827dcFe994AB23944CBC90e0aa80bFcb';

// https://etherscan.io/address/0x223d844fc4B006D67c0cDbd39371A9F73f69d974
export const EMISSION_MANAGER = '0x223d844fc4B006D67c0cDbd39371A9F73f69d974';

// ICollector https://etherscan.io/address/0x464C71f6c2F760DdA6093dCB91C24c39e5d6e18c
export const COLLECTOR = '0x464C71f6c2F760DdA6093dCB91C24c39e5d6e18c';

// https://etherscan.io/address/0x80D786DF608603cCDcC83F5712B97C185A6A948d
export const DEFAULT_A_TOKEN_IMPL = '0x80D786DF608603cCDcC83F5712B97C185A6A948d';

// https://etherscan.io/address/0x79f5C4562EC3e85C3103Ce63Ab94E92EFfDd6197
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x79f5C4562EC3e85C3103Ce63Ab94E92EFfDd6197';

// https://etherscan.io/address/0xC6cAB8D39D93DC0Bd5986E7Ce5Bb956E30103A43
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0xC6cAB8D39D93DC0Bd5986E7Ce5Bb956E30103A43';

// https://etherscan.io/address/0x66E1aBdb06e7363a618D65a910c540dfED23754f
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x66E1aBdb06e7363a618D65a910c540dfED23754f';

// https://etherscan.io/address/0xD0887AA7fEBC8962c622493646195e7c76D94fCE
export const SWAP_COLLATERAL_ADAPTER = '0xD0887AA7fEBC8962c622493646195e7c76D94fCE';

// https://etherscan.io/address/0x43eDB797834151D041619EEF833Edc784B509dAE
export const WITHDRAW_SWAP_ADAPTER = '0x43eDB797834151D041619EEF833Edc784B509dAE';

// https://etherscan.io/address/0xe3dFf4052F0bF6134ACb73bEaE8fe2317d71F047
export const UI_INCENTIVE_DATA_PROVIDER = '0xe3dFf4052F0bF6134ACb73bEaE8fe2317d71F047';

// https://etherscan.io/address/0x56b7A1012765C285afAC8b8F25C69Bf10ccfE978
export const UI_POOL_DATA_PROVIDER = '0x56b7A1012765C285afAC8b8F25C69Bf10ccfE978';

// https://etherscan.io/address/0xC7be5307ba715ce89b152f3Df0658295b3dbA8E2
export const WALLET_BALANCE_PROVIDER = '0xC7be5307ba715ce89b152f3Df0658295b3dbA8E2';

// https://etherscan.io/address/0x3167C452fA3fa1e5C16bB83Bc0fde4519C464299
export const WETH_GATEWAY = '0x3167C452fA3fa1e5C16bB83Bc0fde4519C464299';

// https://etherscan.io/address/0xAB8EbcFaF43340b0003596f6D016964177C294C0
export const CONFIG_ENGINE = '0xAB8EbcFaF43340b0003596f6D016964177C294C0';

// https://etherscan.io/address/0x7e6a6B115D31d4A837E3C737c49Cf6Fafe6112C3
export const RISK_STEWARD = '0x7e6a6B115D31d4A837E3C737c49Cf6Fafe6112C3';

// https://etherscan.io/address/0xd1B2dec98A95B773C4909B5CD8FB455F467A527f
export const DEBT_SWAP_ADAPTER = '0xd1B2dec98A95B773C4909B5CD8FB455F467A527f';

// https://etherscan.io/address/0x81aFd0F99c2Afa2f2DD7E387c2Ef9CD2a29b6E1A
export const EDGE_RISK_STEWARD_RATES = '0x81aFd0F99c2Afa2f2DD7E387c2Ef9CD2a29b6E1A';

// https://etherscan.io/address/0x834a5aC6e9D05b92F599A031941262F761c34859
export const EDGE_INJECTOR_RATES = '0x834a5aC6e9D05b92F599A031941262F761c34859';

// https://etherscan.io/address/0x347C75d19718a05148687E13dca259aD016aB411
export const STATA_FACTORY = '0x347C75d19718a05148687E13dca259aD016aB411';

// https://etherscan.io/address/0x2cE01c87Fec1b71A9041c52CaED46Fc5f4807285
export const GHO_DIRECT_MINTER = '0x2cE01c87Fec1b71A9041c52CaED46Fc5f4807285';

// https://etherscan.io/address/0x31a0Ba3C2242a095dBF58A7C53751eCBd27dBA9b
export const DUST_BIN = '0x31a0Ba3C2242a095dBF58A7C53751eCBd27dBA9b';

// https://etherscan.io/address/0x7571F419F7Df2d0622C1A20154a0D4250B2265cC
export const CLINIC_STEWARD = '0x7571F419F7Df2d0622C1A20154a0D4250B2265cC';

// https://etherscan.io/address/0x84f2C90f2D66E700baA4CF3cbF66bE7D8f21Bd87
export const SVR_STEWARD = '0x84f2C90f2D66E700baA4CF3cbF66bE7D8f21Bd87';

export const CHAIN_ID = 1;
export const ASSETS = {
  wstETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    A_TOKEN: '0xC035a7cf15375cE2706766804551791aD035E0C2',
    V_TOKEN: '0xE439edd2625772AA635B437C099C607B6eb7d35f',
    INTEREST_RATE_STRATEGY: '0x8958b1C39269167527821f8c276Ef7504883f2fa',
    ORACLE: '0xe1D97bF61901B075E9626c8A2340a7De385861Ef',
    STATA_TOKEN: '0x775F661b0bD1739349b9A2A3EF60be277c5d2D29',
  },
  WETH: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    A_TOKEN: '0xfA1fDbBD71B0aA16162D76914d69cD8CB3Ef92da',
    V_TOKEN: '0x91b7d78BF92db564221f6B5AeE744D1727d1Dd1e',
    INTEREST_RATE_STRATEGY: '0x8958b1C39269167527821f8c276Ef7504883f2fa',
    ORACLE: '0x5424384B256154046E9667dDFaaa5e550145215e',
    STATA_TOKEN: '0x0FE906e030a44eF24CA8c7dC7B7c53A6C4F00ce9',
  },
  USDS: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0xdC035D45d973E3EC169d2276DDab16f1e407384F',
    A_TOKEN: '0x09AA30b182488f769a9824F15E6Ce58591Da4781',
    V_TOKEN: '0x2D9fe18b6c35FE439cC15D932cc5C943bf2d901E',
    INTEREST_RATE_STRATEGY: '0x8958b1C39269167527821f8c276Ef7504883f2fa',
    ORACLE: '0x94C7FD62fd0506e71d8142E9D36687fC72A86B02',
  },
  USDC: {
    decimals: 6,
    id: 3,
    UNDERLYING: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    A_TOKEN: '0x2A1FBcb52Ed4d9b23daD17E1E8Aed4BB0E6079b8',
    V_TOKEN: '0xeD90dE2D824Ee766c6Fd22E90b12e598f681dc9F',
    INTEREST_RATE_STRATEGY: '0x8958b1C39269167527821f8c276Ef7504883f2fa',
    ORACLE: '0x3f73F03aa83B2A48ed27E964eD0fDb590332095B',
  },
  ezETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0xbf5495Efe5DB9ce00f80364C8B423567e58d2110',
    A_TOKEN: '0x74e5664394998f13B07aF42446380ACef637969f',
    V_TOKEN: '0x08e1bba76D27841dD91FAb4b3a636A0D5CF8c3E9',
    INTEREST_RATE_STRATEGY: '0x8958b1C39269167527821f8c276Ef7504883f2fa',
    ORACLE: '0xF3d49021fF3bbBFDfC1992A4b09E5D1d141D044C',
  },
  sUSDe: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
    A_TOKEN: '0xc2015641564a5914A17CB9A92eC8d8feCfa8f2D0',
    V_TOKEN: '0x2ABbAab3EF4e4A899d39e7EC996b5715E76b399a',
    INTEREST_RATE_STRATEGY: '0x8958b1C39269167527821f8c276Ef7504883f2fa',
    ORACLE: '0x42bc86f2f08419280a99d8fbEa4672e7c30a86ec',
  },
  GHO: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
    A_TOKEN: '0x18eFE565A5373f430e2F809b97De30335B3ad96A',
    V_TOKEN: '0x18577F0f4A0B2Ee6F4048dB51c7acd8699F97DB8',
    INTEREST_RATE_STRATEGY: '0x8958b1C39269167527821f8c276Ef7504883f2fa',
    ORACLE: '0xD110cac5d8682A3b045D5524a9903E031d70FCCd',
    STATA_TOKEN: '0xC71Ea051a5F82c67ADcF634c36FFE6334793D24C',
  },
  rsETH: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7',
    A_TOKEN: '0x56D919E7B25aA42F3F8a4BC77b8982048F2E84B4',
    V_TOKEN: '0x2c2163f120cf58631368981BC16e90190Bc6C644',
    INTEREST_RATE_STRATEGY: '0x8958b1C39269167527821f8c276Ef7504883f2fa',
    ORACLE: '0x7292C95A5f6A501a9c4B34f6393e221F2A0139c3',
  },
  tETH: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8',
    A_TOKEN: '0xce8c60fd8390eFCc3Fc66A3f0bd64BEb969e750E',
    V_TOKEN: '0xe7ea6125490ae4594aD9B44D05dFF9F2A4343134',
    INTEREST_RATE_STRATEGY: '0x8958b1C39269167527821f8c276Ef7504883f2fa',
    ORACLE: '0x85968026294b8f8Fb86d6bF3Cda079f9376aD05A',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'wstETH / WETH',
    collateralBitmap: '1',
    collateralAssets: ['0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0'],
    borrowableBitmap: '2',
    borrowableAssets: ['0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9500,
    liquidationThreshold: 9650,
    liquidationBonus: 10100,
  },
  '2': {
    label: 'ezETH / USDC,GHO',
    collateralBitmap: '16',
    collateralAssets: ['0xbf5495Efe5DB9ce00f80364C8B423567e58d2110'],
    borrowableBitmap: '72',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7500,
    liquidationThreshold: 7800,
    liquidationBonus: 10750,
  },
  '3': {
    label: 'ezETH / wstETH',
    collateralBitmap: '16',
    collateralAssets: ['0xbf5495Efe5DB9ce00f80364C8B423567e58d2110'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '4': {
    label: 'sUSDe / USDC,GHO',
    collateralBitmap: '32',
    collateralAssets: ['0x9D39A5DE30e57443BfF2A8307A4256c8797A3497'],
    borrowableBitmap: '72',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10400,
  },
  '5': {
    label: 'rsETH / wstETH',
    collateralBitmap: '128',
    collateralAssets: ['0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '6': {
    label: 'rsETH / USDC,GHO',
    collateralBitmap: '128',
    collateralAssets: ['0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7'],
    borrowableBitmap: '72',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7200,
    liquidationThreshold: 7500,
    liquidationBonus: 10750,
  },
  '7': {
    label: 'tETH / wstETH',
    collateralBitmap: '256',
    collateralAssets: ['0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8'],
    borrowableBitmap: '1',
    borrowableAssets: ['0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9200,
    liquidationThreshold: 9400,
    liquidationBonus: 10200,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
